import { render } from "./Home.vue?vue&type=template&id=4947f2b4&scoped=true"
import script from "./Home.vue?vue&type=script&language=ts&lang=js"
export * from "./Home.vue?vue&type=script&language=ts&lang=js"

import "./Home.vue?vue&type=style&index=0&id=4947f2b4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4947f2b4"

export default script